<template>
    <div>
        <iframe v-if="isShow" :src="$apiPath + path" style="border:0px; width:100%; height:100%;"></iframe>
        <img :src="require('@/assets/exit.png')" style="width:30px; position:fixed; left:10px; top: 10px;" @click="close">
    </div>
</template>

<script>
    export default {
        name: "KaKaoLogin",
        data(){
            return {
                uuid : '', 
                pushToken : '',
                isShow : false, 
                path : 'login/kakao/form'
            }
        },
        methods : {
            close(){
                this.$GlobalStore.closeLastModal();
            }
        },
        mounted(){
        },
        async created(){
            const device = this.$cookies.get('device');
            if(device === 'android' || device === 'ios'){
                const pushToken = await window.pushCustomManager.getPushToken();
                const uuid = await window.pushCustomManager.getUuid();
                const marketingAgree = localStorage.getItem('marketing_agree') ?? '';
                this.path += '?uuid=' + uuid + "&pushToken=" + pushToken + "&marketingAgree=" + marketingAgree;
                this.isShow = true;
            }else {
                this.isShow = true;
            }
        }
    }
</script>

<style scoped>

</style>